import React from "react";
import { Link } from "react-router-dom";

const LOGO = "https://customer-assets-0z36b82j.emergentagent.net/job_gray-spirit-gear/artifacts/qoih72dz_glogo.jpeg";
const DJ_LOGO = "https://customer-assets-0z36b82j.emergentagent.net/job_gray-spirit-gear/artifacts/bn2c9jw5_Untitled%20design%20%2832%29.webp";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0A0A0A] mt-20">
    <div className="max-w-7xl mx-auto px-6 py-12">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <img src={LOGO} alt="Gray War Eagles" className="w-8 h-8 rounded-full bg-white object-contain" />
            <span className="font-display text-2xl">GRAY COLLEGIATE ACADEMY VOLLEYBALL</span>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-2">War Eagles • Official Team Store</p>
          <p className="text-sm text-gray-400 max-w-md">15% of merchandise sales are donated back to the Gray Volleyball program.</p>
        </div>
        <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs uppercase tracking-[0.2em] text-gray-500 hover:text-[var(--gv-blue-bright)]">Admin</Link>
      </div>
      <div className="mt-6 flex flex-wrap gap-4">
        <Link to="/schedule" data-testid="footer-schedule-link" className="text-xs uppercase tracking-[0.2em] text-gray-400 hover:text-[var(--gv-blue-bright)]">Schedule</Link>
        <Link to="/faq" data-testid="footer-faq-link" className="text-xs uppercase tracking-[0.2em] text-gray-400 hover:text-[var(--gv-blue-bright)]">FAQ</Link>
        <Link to="/gameday" className="text-xs uppercase tracking-[0.2em] text-gray-400 hover:text-[var(--gv-blue-bright)]">Game Day</Link>
      </div>
      <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-400">
        <a href="mailto:dadjerzeys@gmail.com" data-testid="footer-email-link" className="hover:text-[var(--gv-blue-bright)] transition-colors">dadjerzeys@gmail.com</a>
        <a href="tel:8038302211" data-testid="footer-phone-link" className="hover:text-[var(--gv-blue-bright)] transition-colors">(803) 830-2211</a>
      </div>
      <div className="mt-8 pt-6 border-t border-white/5 flex flex-col items-center gap-3 text-center">
        <a href="https://www.dadjerzeys.com" target="_blank" rel="noopener noreferrer" data-testid="footer-dadjerzeys-logo" className="bg-white rounded-lg px-4 py-2 inline-flex items-center justify-center hover:opacity-90 transition-opacity">
          <img src={DJ_LOGO} alt="Dad Jerzeys" className="h-10 object-contain" />
        </a>
        <p className="text-sm text-gray-400">Official team store powered by{" "}
          <a href="https://www.dadjerzeys.com" target="_blank" rel="noopener noreferrer" data-testid="footer-dadjerzeys-link" className="text-white font-bold hover:text-[var(--gv-blue-bright)] transition-colors">Dad Jerzeys</a>
          {" "}— custom parent sports jerseys
        </p>
      </div>
    </div>
  </footer>
);
